export default __webpack_public_path__ + "static/airplane-e1c2285ebc021eb6cb4e050a28198b14.gif";